import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getIsSoundsEnabledForCurrentUser } from './soundEnabledSelector';
import { initialiseSounds } from './soundService';
import { useRomaCheckboxSounds } from './useRomaCheckboxSounds';

/**
 * Creates the audio graph and preloads all UX sounds as soon as sounds are enabled for the
 * current user, so they're ready to play immediately when first triggered.
 */
const SoundInitialiser = () => {
    const isSoundsEnabled = useSelector(getIsSoundsEnabledForCurrentUser);

    useEffect(() => {
        if (isSoundsEnabled) initialiseSounds();
    }, [isSoundsEnabled]);

    useRomaCheckboxSounds(isSoundsEnabled);

    return null;
};

export default SoundInitialiser;
